export const translations = {
  en: {
    nav: { map: 'Expert Map', register: 'Become an Expert', admin: 'Admin Portal' },
    hero: {
      title: 'Minecraft Education Experts in Jordan',
      subtitle: 'Connect with experienced Minecraft Education teachers across Jordan. Find mentors, share knowledge, and build collaborative learning communities.'
    },
    stats: { total: 'Total Experts', governorates: 'Governorates', topics: 'Support Topics' },
    search: { placeholder: 'Search by name...', allGovs: 'All Governorates', allTopics: 'All Topics', button: 'Search' },
    register: {
      title: 'Join the Network',
      subtitle: 'Share your Minecraft Education expertise with teachers across Jordan.',
      info: 'Your profile will be automatically placed on our graphical map based on your selected Governorate.',
      fullName: 'Full Name',
      email: 'Email Address',
      govLabel: 'Governorate',
      cityLabel: 'Specific City/Area',
      bio: 'Professional Bio',
      topics: 'Support Topics',
      consent: 'I certify that I am a certified educator in Jordan and I consent to having my profile displayed on the national expert map once verified.',
      submit: 'Submit Expert Profile',
      processing: 'Processing Application...',
      successTitle: 'Application Submitted!',
      successStatus: 'Status: Pending Verification',
      successMsg: 'Our team will review your credentials. Once approved, you\'ll appear on the national expert map.',
      redirect: 'Redirecting to home page...'
    },
    reviews: {
      title: 'Ratings & Reviews',
      noReviews: 'No reviews yet. Be the first to share your experience!',
      leaveReview: 'Leave a Review',
      ratingLabel: 'Your Rating',
      nameLabel: 'Your Name',
      commentLabel: 'Your Experience',
      submit: 'Post Review',
      success: 'Thank you! Your review has been posted.',
      averageRating: 'Average Rating'
    },
    map: { grid: 'Network Grid', govLabel: 'Governorate', activeExpert: 'Active Expert', experts: 'Experts', footer: 'Jordan Network Grid' },
    modal: {
      about: 'About',
      expertise: 'Areas of Expertise',
      contact: 'Contact Information',
      sendMessage: 'Send Message',
      directEmail: 'Direct Email',
      name: 'Your Name',
      email: 'Your Email',
      message: 'Message',
      cancel: 'Cancel',
      sending: 'Sending...',
      sent: 'Message Sent!',
      sentDesc: 'Your message has been sent successfully.'
    }
  },
  ar: {
    nav: { map: 'خريطة الخبراء', register: 'كن خبيراً', admin: 'بوابة المسؤول' },
    hero: {
      title: 'خبراء ماينكرافت التعليمية في الأردن',
      subtitle: 'تواصل مع معلمين ذوي خبرة في ماينكرافت التعليمية في جميع أنحاء الأردن. ابحث عن مرشدين، شارك المعرفة، وابنِ مجتمعات تعليمية تعاونية.'
    },
    stats: { total: 'إجمالي الخبراء', governorates: 'المحافظات', topics: 'مواضيع الدعم' },
    search: { placeholder: 'البحث بالاسم...', allGovs: 'جميع المحافظات', allTopics: 'جميع المواضيع', button: 'بحث' },
    register: {
      title: 'انضم إلى الشبكة',
      subtitle: 'شارك خبرتك في ماينكرافت التعليمية مع المعلمين في جميع أنحاء الأردن.',
      info: 'سيتم وضع ملفك الشخصي تلقائياً على خريطتنا الرسومية بناءً على المحافظة المختارة.',
      fullName: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      govLabel: 'المحافظة',
      cityLabel: 'المدينة / المنطقة',
      bio: 'السيرة المهنية',
      topics: 'مواضيع الدعم',
      consent: 'أقر بأنني معلم معتمد في الأردن وأوافق على عرض ملفي الشخصي على خريطة الخبراء الوطنية بمجرد التحقق منه.',
      submit: 'إرسال ملف الخبير',
      processing: 'جاري معالجة الطلب...',
      successTitle: 'تم تقديم الطلب!',
      successStatus: 'الحالة: قيد التحقق',
      successMsg: 'سيقوم فريقنا بمراجعة مؤهلاتك. بمجرد الموافقة، ستظهر على خريطة الخبراء الوطنية.',
      redirect: 'جاري التحويل إلى الصفحة الرئيسية...'
    },
    reviews: {
      title: 'التقييمات والآراء',
      noReviews: 'لا توجد تقييمات بعد. كن أول من يشارك تجربته!',
      leaveReview: 'اترك تقييماً',
      ratingLabel: 'تقييمك',
      nameLabel: 'اسمك',
      commentLabel: 'تجربتك',
      submit: 'نشر التقييم',
      success: 'شكراً لك! تم نشر تقييمك بنجاح.',
      averageRating: 'متوسط التقييم'
    },
    map: { grid: 'شبكة التواصل', govLabel: 'محافظة', activeExpert: 'خبير نشط', experts: 'خبراء', footer: 'شبكة الأردن الرقمية' },
    modal: {
      about: 'حول الخبير',
      expertise: 'مجالات الخبرة',
      contact: 'معلومات التواصل',
      sendMessage: 'إرسال رسالة',
      directEmail: 'بريد مباشر',
      name: 'اسمك',
      email: 'بريدك الإلكتروني',
      message: 'الرسالة',
      cancel: 'إلغاء',
      sending: 'جاري الإرسال...',
      sent: 'تم الإرسال!',
      sentDesc: 'تم إرسال رسالتك بنجاح.'
    }
  }
};